/* Scoped to the conversion duplicate; the original research timeline is unchanged. */
if (!customElements.get('nmn-conversion-timeline')) {
  customElements.define('nmn-conversion-timeline', class extends HTMLElement {
    connectedCallback() {
      this.rows = [...this.querySelectorAll('[data-pathway-step]')];
      this.panels = [...this.querySelectorAll('[data-pathway-panel]')];
      if (!this.rows.length) return;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = matchMedia('(max-width: 749px)');
      this.onClick = event => {
        const button = event.target.closest('[data-pathway-button]');
        if (button && this.contains(button)) this.activate(button.closest('[data-pathway-step]').dataset.pathwayStep);
      };
      this.onSelect = event => {
        const row = this.rows.find(item => item.dataset.pathwayStep === event.detail.blockId);
        if (row) this.activate(row.dataset.pathwayStep);
      };
      this.onMotion = () => this.syncVideos();
      this.addEventListener('click', this.onClick);
      document.addEventListener('shopify:block:select', this.onSelect);
      this.motion.addEventListener('change', this.onMotion);
      this.mobile.addEventListener('change', this.onMotion);
      this.classList.add('is-enhanced');
      this.activate(this.rows[0].dataset.pathwayStep);
      if ('IntersectionObserver' in window) {
        this.onResize = () => {
          this.rowObserver?.disconnect();
          // Pixel margins keep the trigger at 60% of height at every aspect ratio.
          const height = window.innerHeight;
          const top = Math.round(height * 0.6);
          this.rowObserver = new IntersectionObserver(entries => {
            const current = entries.find(entry => entry.isIntersecting);
            if (current) this.activate(current.target.dataset.pathwayStep);
          }, { rootMargin: `-${top}px 0px -${Math.max(0, height - top - 1)}px 0px`, threshold: 0 });
          this.rows.forEach(row => this.rowObserver.observe(row));
        };
        window.addEventListener('resize', this.onResize);
        this.onResize();
        this.mediaObserver = new IntersectionObserver(entries => {
          this.mediaVisible = entries.some(entry => entry.isIntersecting);
          this.syncVideos();
        }, { threshold: 0.1 });
        this.mediaObserver.observe(this.querySelector('.nmn-pathway__media'));
      }
    }
    activate(id) {
      if (this.activeId === id) return;
      this.activeId = id;
      this.rows.forEach(row => {
        const selected = row.dataset.pathwayStep === id;
        row.classList.toggle('is-active', selected);
        row.querySelector('button').setAttribute('aria-pressed', String(selected));
      });
      this.panels.forEach(panel => { panel.hidden = panel.dataset.pathwayPanel !== id; });
      this.syncVideos();
    }
    syncVideos() {
      this.panels.forEach(panel => {
        const video = panel.querySelector('video');
        if (!video) return;
        if (!panel.hidden && this.mediaVisible && !this.motion.matches && !this.mobile.matches) video.play()?.catch(() => {});
        else video.pause();
      });
    }
    disconnectedCallback() {
      this.rowObserver?.disconnect();
      this.mediaObserver?.disconnect();
      this.removeEventListener('click', this.onClick);
      document.removeEventListener('shopify:block:select', this.onSelect);
      this.motion?.removeEventListener('change', this.onMotion);
      this.mobile?.removeEventListener('change', this.onMotion);
      window.removeEventListener('resize', this.onResize);
      this.panels?.forEach(panel => { panel.hidden = false; panel.querySelector('video')?.pause(); });
      this.classList.remove('is-enhanced');
      this.activeId = null;
      this.mediaVisible = false;
    }
  });
}
